import { render, staticRenderFns } from "./ContentInput.vue?vue&type=template&id=c9af76dc&scoped=true"
import script from "./ContentInput.vue?vue&type=script&lang=js"
export * from "./ContentInput.vue?vue&type=script&lang=js"
import style0 from "./ContentInput.vue?vue&type=style&index=0&id=c9af76dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9af76dc",
  null
  
)

export default component.exports